import { PIPELINE_SCHEDULE_TOKENS, SCHEDULE_DEMO_TOKEN } from "lib/constants";

export const getScheduleKey = (path: string = "") => {
  return PIPELINE_SCHEDULE_TOKENS[path] || SCHEDULE_DEMO_TOKEN;
};
